<div
  class="activity-form flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif]">
  <div
    class="flex flex-col gap-[40px] w-full flex-1 px-[24px] sm:px-[80px] lg:px-[200px] xl:px-[360px] pt-[40px] pb-[40px]">
    <div class="w-full flex flex-row items-center justify-start">
      <button
        type="button"
        class="activity-form__back-btn"
        (click)="goBack()"
        aria-label="Back">
        <svg class="activity-form__back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Back</span>
      </button>
    </div>

    <div class="flex flex-col items-center gap-[8px] text-center w-full">
      <h1 class="activity-form__page-title m-0">
        {{ pageTitle }}
      </h1>
      <p class="activity-form__page-subtitle m-0 max-w-[720px]">
        {{ pageSubtitle }}
      </p>
    </div>
    

    <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full py-[40px] gap-3">
      <div class="w-10 h-10 border-4 border-[#f26f24] border-t-transparent rounded-full animate-spin"></div>
      <span class="text-[#667085] text-[14px] leading-[18px]">Loading activity…</span>
    </div>

    <div class="flex flex-col gap-[20px] w-full" *ngIf="!isLoading">
      <h2 class="activity-form__section-title m-0">
        Basic details
      </h2>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px] leading-[18px]">
        {{ errorMessage }}
      </div>
      <div *ngIf="successMessage" class="text-green-700 text-[14px] leading-[18px]">
        {{ successMessage }}
      </div>

      <div class="flex flex-row flex-wrap items-center gap-[20px]">
        <div
          class="w-[120px] h-[120px] rounded-[8px] bg-[#EAECF0] flex items-center justify-center overflow-hidden shrink-0">
          <img
            *ngIf="thumbnailPreviewUrl; else placeholderThumb"
            [src]="thumbnailPreviewUrl"
            alt="Activity thumbnail preview"
            class="w-full h-full object-cover"
            (error)="onThumbnailPreviewError()" />
          <ng-template #placeholderThumb>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#98A2B3" stroke-width="1.5" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          </ng-template>
        </div>

        <div class="flex flex-col gap-[8px] items-start">
          <span class="activity-form__thumb-title">Thumbnail Image</span>
          <span class="activity-form__thumb-hint">
            JPG, PNG, PDF, DOCX - maximum 5 MB
          </span>
          <span *ngIf="thumbnailDisplayName || thumbnailFileName" class="activity-form__thumb-file">
            {{ thumbnailDisplayName || thumbnailFileName }}
          </span>
          <span *ngIf="isUploadingThumbnail" class="text-[13px] text-[#667085]">Uploading…</span>
          <button
            type="button"
            class="activity-form__upload-btn"
            [disabled]="isUploadingThumbnail || isSaving"
            (click)="triggerUpload()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M12 16V4M12 4l-4 4M12 4l4 4" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke-linecap="round" />
            </svg>
            {{ isUploadingThumbnail ? 'Uploading…' : thumbnailFileName ? 'Change' : 'Upload' }}
          </button>
          <input
            #fileInput
            type="file"
            class="hidden"
            accept=".jpg,.jpeg,.png,.pdf,.docx,image/*,application/pdf"
            (change)="onFileSelected($event)" />
        </div>
      </div>

      <div class="activity-form__fields grid grid-cols-1 md:grid-cols-2 gap-x-[24px] gap-y-[16px] w-full">
        <label class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Activity Name</span>
          <input
            type="text"
            class="activity-form__input"
            [(ngModel)]="activityName"
            name="activityName" />
        </label>

        <label class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Code</span>
          <input
            type="text"
            class="activity-form__input"
            [(ngModel)]="code"
            name="code"
            [readonly]="isCodeAutoManaged"
            [attr.aria-readonly]="isCodeAutoManaged"
            [attr.aria-describedby]="'activity-code-hint'" />
          <span id="activity-code-hint" class="activity-form__field-hint">
            {{ codeHint }}
          </span>
        </label>

        <label class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Type</span>
          <select
            class="activity-form__input"
            [class.text-[#A1A4AA]]="!type"
            [style.color]="type ? '#333740' : null"
            [(ngModel)]="type"
            (ngModelChange)="onTypeChanged()"
            name="type">
            <option value="">Select</option>
            <option *ngFor="let option of typeOptions" [value]="option">{{ option }}</option>
          </select>
        </label>

        <div class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Domains of Wellness</span>
          <div class="relative">
            <div
              class="activity-form__domain-field w-full pl-[12px] pr-[16px] py-[8px] flex flex-wrap items-center gap-[8px] text-left bg-[#F9FAFB] cursor-default"
              aria-readonly="true">
              <ng-container *ngIf="domainsOfWellness.length; else domainPlaceholder">
                <span
                  *ngFor="let domain of domainsOfWellness"
                  class="activity-form__domain-chip inline-flex items-center gap-[6px] rounded-full bg-white border border-[#D0D5DD] pl-[10px] pr-[10px] py-[4px]">
                  {{ domain }}
                </span>
              </ng-container>
              <ng-template #domainPlaceholder>
                <span class="activity-form__placeholder">Select a Type to set domains</span>
              </ng-template>
            </div>
          </div>
        </div>

        <label class="flex flex-col gap-[8px] md:col-span-2">
          <span class="activity-form__label">Description</span>
          <textarea
            class="activity-form__input activity-form__input--textarea"
            [(ngModel)]="description"
            name="description"
            rows="3"></textarea>
        </label>

        <label class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Limited Capacity</span>
          <input
            type="number"
            class="activity-form__input"
            [(ngModel)]="limitedCapacity"
            (ngModelChange)="onCapacityInput($event)"
            name="limitedCapacity"
            min="0"
            step="1"
            inputmode="numeric"
            pattern="[0-9]*"
            placeholder="Enter whole number" />
        </label>

        <label class="flex flex-col gap-[8px]">
          <span class="activity-form__label">Center</span>
          <select
            class="activity-form__input"
            [class.text-[#A1A4AA]]="!center"
            [style.color]="center ? '#333740' : null"
            [(ngModel)]="center"
            name="center">
            <option value="">Select</option>
            <option *ngFor="let option of centerOptions" [value]="option">{{ option }}</option>
          </select>
          <span class="text-[12px] text-[#667085] font-['Archivo']">
            Choose All Centers to share one activity across every location.
          </span>
        </label>

        <!-- Special Activity | Series — two columns, label+radios on one line each -->
        <div class="activity-form__inline-row">
          <span class="activity-form__label activity-form__inline-label">Special Activity</span>
          <div class="activity-form__inline-options">
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="isSpecialEvent === true"
              (click)="setSpecialEvent(true)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Yes
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="isSpecialEvent === false"
              (click)="setSpecialEvent(false)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              No
            </button>
          </div>
        </div>

        <div class="activity-form__inline-row">
          <span class="activity-form__label activity-form__inline-label">Series</span>
          <div class="activity-form__inline-options">
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="isSeries === true"
              (click)="setSeries(true)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Yes
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="isSeries === false"
              (click)="setSeries(false)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              No
            </button>
          </div>
        </div>

        <div class="activity-form__inline-row md:col-span-2">
          <span class="activity-form__label activity-form__inline-label">Service Delivery Needed?</span>
          <div class="activity-form__inline-options">
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="serviceDeliveryNeeded === true"
              (click)="setServiceDeliveryNeeded(true)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Yes
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="serviceDeliveryNeeded === false"
              (click)="setServiceDeliveryNeeded(false)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              No
            </button>
          </div>
        </div>

        <div class="activity-form__inline-row md:col-span-2">
          <span class="activity-form__label activity-form__inline-label">Need Special Menu?</span>
          <div class="activity-form__inline-options">
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="needsSpecialMenu === true"
              (click)="setNeedsSpecialMenu(true)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Yes
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="needsSpecialMenu === false"
              (click)="setNeedsSpecialMenu(false)">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              No
            </button>
          </div>
        </div>

        <div
          class="activity-form__inline-row md:col-span-2"
          *ngIf="needsSpecialMenu === true">
          <span class="activity-form__label activity-form__inline-label">Special Menu Options</span>
          <div class="activity-form__inline-options activity-form__inline-options--wrap">
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="specialMenuOfferMode === 'hot_only'"
              (click)="setSpecialMenuOfferMode('hot_only')">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Hot Meal Only
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="specialMenuOfferMode === 'cold_only'"
              (click)="setSpecialMenuOfferMode('cold_only')">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Cold Meal Only
            </button>
            <button
              type="button"
              class="activity-form__radio"
              [class.activity-form__radio--selected]="specialMenuOfferMode === 'both'"
              (click)="setSpecialMenuOfferMode('both')">
              <span class="activity-form__radio-dot" aria-hidden="true"></span>
              Cold and Hot Meal
            </button>
          </div>
        </div>
      </div>

      <div class="activity-form__schedule flex flex-col w-full">
        <h2 class="activity-form__section-title m-0">
          Time and Reoccurring
        </h2>

        <!-- Figma: [Time + radios] | [Start Time] [End Time] -->
        <div class="activity-form__schedule-row">
          <div class="activity-form__inline-row">
            <span class="activity-form__label activity-form__inline-label">Time</span>
            <div class="activity-form__inline-options">
              <button
                type="button"
                class="activity-form__radio"
                [class.activity-form__radio--selected]="timeMode === 'all_day'"
                (click)="setTimeMode('all_day')">
                <span class="activity-form__radio-dot" aria-hidden="true"></span>
                All Day Event
              </button>
              <button
                type="button"
                class="activity-form__radio"
                [class.activity-form__radio--selected]="timeMode === 'specific'"
                (click)="setTimeMode('specific')">
                <span class="activity-form__radio-dot" aria-hidden="true"></span>
                Specific Time
              </button>
            </div>
          </div>

          <div class="activity-form__schedule-right grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
            <label class="flex flex-col gap-[8px]">
              <span class="activity-form__label">Start Time</span>
              <div class="relative">
                <span *ngIf="showPickerPlaceholder('startTime')" class="activity-form__picker-placeholder">Select Time</span>
                <input
                  #startTimeInput
                  type="time"
                  class="activity-form__input activity-form__input--picker activity-form__input--icon-left"
                  [class.activity-form__input--empty]="showPickerPlaceholder('startTime')"
                  [(ngModel)]="startTime"
                  name="startTime"
                  [disabled]="timeMode === 'all_day'"
                  (focus)="onPickerFocus('startTime'); setTimeMode('specific')"
                  (blur)="onPickerBlur('startTime')"
                  (change)="setTimeMode('specific')" />
                <button
                  type="button"
                  class="activity-form__field-icon activity-form__field-icon--left"
                  [disabled]="timeMode === 'all_day'"
                  (click)="setTimeMode('specific'); openNativePicker(startTimeInput)"
                  aria-label="Select start time">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="1.75" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </label>

            <label class="flex flex-col gap-[8px]">
              <span class="activity-form__label">End Time</span>
              <div class="relative">
                <span *ngIf="showPickerPlaceholder('endTime')" class="activity-form__picker-placeholder">Select Time</span>
                <input
                  #endTimeInput
                  type="time"
                  class="activity-form__input activity-form__input--picker activity-form__input--icon-left"
                  [class.activity-form__input--empty]="showPickerPlaceholder('endTime')"
                  [(ngModel)]="endTime"
                  name="endTime"
                  [disabled]="timeMode === 'all_day'"
                  (focus)="onPickerFocus('endTime'); setTimeMode('specific')"
                  (blur)="onPickerBlur('endTime')"
                  (change)="setTimeMode('specific')" />
                <button
                  type="button"
                  class="activity-form__field-icon activity-form__field-icon--left"
                  [disabled]="timeMode === 'all_day'"
                  (click)="setTimeMode('specific'); openNativePicker(endTimeInput)"
                  aria-label="Select end time">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="1.75" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </label>
          </div>
        </div>

        <!-- Figma: [Reoccurring + radios] | [Reoccurring Days chips] -->
        <div class="activity-form__schedule-row">
          <div class="activity-form__inline-row">
            <span class="activity-form__label activity-form__inline-label">Reoccurring</span>
            <div class="activity-form__inline-options">
              <button
                *ngFor="let option of visibleReoccurringOptions"
                type="button"
                class="activity-form__radio"
                [class.activity-form__radio--selected]="reoccurring === option"
                (click)="setReoccurring(option)">
                <span class="activity-form__radio-dot" aria-hidden="true"></span>
                {{ option }}
              </button>
            </div>
          </div>

          <div class="activity-form__schedule-right flex flex-col gap-[8px]" *ngIf="reoccurring === 'Weekly'">
            <span class="activity-form__label">Reoccurring Days</span>
            <div class="flex flex-row flex-wrap items-center gap-[8px]">
              <button
                *ngFor="let day of weekDays"
                type="button"
                class="activity-form__day"
                [class.activity-form__day--selected]="isDaySelected(day.value)"
                (click)="toggleReoccurringDay(day.value)"
                [attr.aria-pressed]="isDaySelected(day.value)">
                {{ day.label }}
              </button>
            </div>
          </div>

          <div class="activity-form__schedule-right flex flex-col gap-[10px]" *ngIf="reoccurring === 'Monthly'">
            <span class="activity-form__label">Monthly Occurrence</span>
            <div class="flex flex-col gap-[8px]">
              <span class="activity-form__sublabel">Week of month</span>
              <div class="flex flex-row flex-wrap items-center gap-[8px]">
                <button
                  *ngFor="let ordinal of monthlyOrdinals"
                  type="button"
                  class="activity-form__chip"
                  [class.activity-form__chip--selected]="monthlyOrdinal === ordinal"
                  (click)="setMonthlyOrdinal(ordinal)"
                  [attr.aria-pressed]="monthlyOrdinal === ordinal">
                  {{ ordinal }}
                </button>
              </div>
            </div>
            <div class="flex flex-col gap-[8px]">
              <span class="activity-form__sublabel">Day</span>
              <div class="flex flex-row flex-wrap items-center gap-[8px]">
                <button
                  *ngFor="let day of weekDays"
                  type="button"
                  class="activity-form__day"
                  [class.activity-form__day--selected]="monthlyWeekday === day.value"
                  (click)="setMonthlyWeekday(day.value)"
                  [attr.aria-pressed]="monthlyWeekday === day.value">
                  {{ day.label }}
                </button>
              </div>
            </div>
            <span class="activity-form__hint" *ngIf="monthlyOccurrenceLabel">
              Happens on the {{ monthlyOccurrenceLabel }} of each month.
            </span>
          </div>
        </div>

        <div class="activity-form__dates grid grid-cols-1 sm:grid-cols-2 gap-x-[24px] gap-y-[16px] w-full">
          <label class="flex flex-col gap-[8px]">
            <span class="activity-form__label">From Date</span>
            <div class="relative">
              <span *ngIf="showPickerPlaceholder('fromDate')" class="activity-form__picker-placeholder">Select Dates</span>
              <input
                #fromDateInput
                type="date"
                class="activity-form__input activity-form__input--picker activity-form__input--icon-left"
                [class.activity-form__input--empty]="showPickerPlaceholder('fromDate')"
                [(ngModel)]="fromDate"
                name="fromDate"
                (ngModelChange)="onFromDateChange($event)"
                (focus)="onPickerFocus('fromDate')"
                (blur)="onPickerBlur('fromDate')" />
              <button
                type="button"
                class="activity-form__field-icon activity-form__field-icon--left"
                (click)="openNativePicker(fromDateInput)"
                aria-label="Select from date">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="1.75" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="16" rx="2" />
                  <path d="M3 10h18M8 3v4M16 3v4" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          </label>

          <label class="flex flex-col gap-[8px]">
            <span class="activity-form__label">Thru Date</span>
            <div class="relative">
              <span *ngIf="showPickerPlaceholder('thruDate')" class="activity-form__picker-placeholder">Select Dates</span>
              <input
                #thruDateInput
                type="date"
                class="activity-form__input activity-form__input--picker activity-form__input--icon-left"
                [class.activity-form__input--empty]="showPickerPlaceholder('thruDate')"
                [(ngModel)]="thruDate"
                name="thruDate"
                [disabled]="isOneTimeEvent"
                (ngModelChange)="onThruDateChange($event)"
                (focus)="onPickerFocus('thruDate')"
                (blur)="onPickerBlur('thruDate')" />
              <button
                type="button"
                class="activity-form__field-icon activity-form__field-icon--left"
                [disabled]="isOneTimeEvent"
                (click)="openNativePicker(thruDateInput)"
                aria-label="Select thru date">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="1.75" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="16" rx="2" />
                  <path d="M3 10h18M8 3v4M16 3v4" stroke-linecap="round" />
                </svg>
              </button>
            </div>
            <span *ngIf="isOneTimeEvent" class="text-[12px] text-[#667085] font-['Archivo']">
              For one-time events, Thru Date matches From Date.
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div
    class="activity-form__footer sticky bottom-0 z-10 w-full px-[24px] sm:px-[80px] lg:px-[200px] xl:px-[360px] py-[20px]">
    <div class="flex flex-row flex-wrap items-center justify-between gap-[12px] w-full">
      <button
        type="button"
        class="activity-form__btn activity-form__btn--secondary"
        (click)="onCancel()">
        <span aria-hidden="true">←</span>
        Cancel
      </button>

      <div class="flex flex-row flex-wrap items-center gap-[12px]">
        <button
          type="button"
          class="activity-form__btn activity-form__btn--secondary"
          [disabled]="isSaving"
          (click)="onSaveDraft()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
          </svg>
          {{ isSaving ? 'Saving…' : 'Save as Draft' }}
        </button>

        <button
          type="button"
          class="activity-form__btn activity-form__btn--primary"
          [disabled]="isSaving"
          (click)="onSavePublish()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M8.5 12.5 11 15l4.5-5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ isSaving ? 'Saving…' : 'Save and Publish' }}
        </button>
      </div>
    </div>
  </div>
</div>
